@if (!isLoading) {
  <div
    class="page-container"
    [ngStyle]="{
      '--color50': booking.seminar.category.color50,
      '--color0': booking.seminar.category.color0,
      '--color70': booking.seminar.category.color70,
      '--color80': booking.seminar.category.color80,
      '--color90': booking.seminar.category.color90,
    }">
    <div class="message-container">
      <i class="fa-regular fa-check icon title-color"></i>
      <div class="font-medium-headline-medium text-align-center title-color">
        Ihre Anmeldung wurde erfolgreich durchgeführt.
      </div>
      @if (booking.invoice.paymentMethod === 'paypal') {
        <span class="text-align-center font-color-black">
          Du hast dich erfolgreich für den Kurs
          <strong>{{ booking.seminar.title }}</strong> eingeschrieben. Wir haben
          dir eine Bestätigungsmail an
          <strong>{{ booking.invoice?.email }}</strong> gesendet.
        </span>
      } @else {
        <span class="text-align-center font-color-black">
          Wir haben eine E-Mail an
          <strong>{{ booking.invoice?.email }}</strong> gesendet, in der wir
          bestätigen, dass wir deine Anfrage für den Zugang zum Kurs
          <strong>{{ booking.seminar.title }}</strong> erhalten haben. Sobald
          wir deine Zahlung bestätigen, erhältst du eine weitere
          Bestätigungs-E-Mail für den Zugang zum Kurs.
        </span>
      }
      <div
        id="to-course-overview"
        class="flex-r align-self-center padding-16-0">
        <button
          type="button"
          class="inwi-text-button-large-primary"
          (click)="toCourseOverview()">
          <div class="button-content">
            <div class="button-text">Weitere Kurse ansehen</div>
          </div>
        </button>
      </div>
    </div>
  </div>
} @else {
  <div class="loading-wrapper">
    <mat-spinner class="loading-spinner"></mat-spinner>
  </div>
}
